var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card-body position-relative p-0",
      attrs: { id: "emails-select-container" },
    },
    [
      _c("div", { class: _vm.spaceClasses }, [
        _c(
          "div",
          { class: _vm.formGroupClass },
          [
            _c("select2", {
              ref: "select",
              attrs: {
                id: "emails-select",
                data: _vm.emails,
                value: _vm.value,
                name: "emails",
                options: _vm.options,
                "init-on-mounted": false,
                "format-data": _vm.formatData,
                multiple: _vm.multiple || null,
                required: _vm.required,
                disabled: _vm.disabled,
              },
              on: { change: _vm.handleChange },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "bar" }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "title text-light-gray mb-2 mb-lg-0",
                attrs: {
                  for: "emails-select",
                  hidden: _vm.materialDesign && _vm.showLabel,
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$tc("global.actions.selectEmail", _vm.multiple ? 2 : 1)
                  )
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }